"use client";

import { c as _c } from "react/compiler-runtime";
import { Receipt, LayoutDashboard, Coins, Settings, HardHat, Landmark, FolderKanban } from "lucide-react";
import { NavLink } from "./nav-link";
export function Navbar(t0) {
  const $ = _c(11);
  const {
    user
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary shadow-lg shadow-primary/20"><HardHat className="h-5 w-5 text-primary-foreground" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex h-20 flex-col justify-center px-6 border-b border-border/50 bg-muted/20"><div className="flex items-center gap-3">{t1}<div className="flex flex-col"><span className="text-sm font-bold tracking-tight text-foreground uppercase">GSJ Engineering</span><span className="text-[10px] font-medium text-muted-foreground uppercase tracking-widest">Core ERP System</span></div></div></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mb-4 px-2 text-[10px] font-bold uppercase tracking-widest text-muted-foreground/60">Menu</div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex-1 overflow-y-auto px-4 py-6">{t3}<nav className="flex flex-col gap-1.5"><NavLink href="/" label="Dashboard" icon={LayoutDashboard} /><NavLink href="/faktury" label="Fakturace" icon={Receipt} /><NavLink href="/rezie" label={"Provozn\xED re\u017Eie"} icon={Coins} /><NavLink href="/dph" label="DPH" icon={Landmark} /><NavLink href="/zakazky" label="Zakazky" icon={FolderKanban} /></nav></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <NavLink href="/nastaveni" label={"Nastaven\xED syst\xE9mu"} icon={Settings} />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="h-8 w-8 rounded-full bg-gradient-to-tr from-primary to-blue-600 flex items-center justify-center text-[10px] font-bold text-white">JJ</div>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== user.name) {
    t7 = <p className="text-xs font-bold truncate">{user.name}</p>;
    $[6] = user.name;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="text-[10px] text-muted-foreground truncate uppercase font-medium">Administrátor</p>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t7) {
    t9 = <aside className="sticky top-0 left-0 z-40 flex h-screen w-72 flex-col border-r bg-background/50 backdrop-blur-xl">{t2}{t4}<div className="mt-auto border-t border-border/50 p-4 bg-muted/5">{t5}<div className="mt-4 flex items-center gap-3 rounded-xl border border-border/50 bg-background p-3 shadow-sm">{t6}<div className="flex flex-col min-w-0">{t7}{t8}</div></div></div></aside>;
    $[9] = t7;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}